angular.module('picmonicng').directive('img', function () {
  return {
    restrict: 'E',
    link: function (scope, el, attr) {
      el.on('error', function () {
        if (attr['ngError']) {
          scope.$eval(attr['ngError']);
        }
      });
    },
  };
});
